import script from "./AvisoAppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvisoAppModal.vue?vue&type=script&lang=ts&setup=true"

import "./AvisoAppModal.vue?vue&type=style&index=0&id=689f9918&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689f9918"]])

export default __exports__